export default __webpack_public_path__ + "static/Kontaktseite-halbfrei-8c5cdd38a1431d6c4ceea4e31cb555fe.png";